import Cookie from 'js-cookie'

export default {
    setToken(value : string, token: string,  expires : number = 1) {
        // console.log('set:',value)
        Cookie.set(token, value, { expires });
    },

    getToken(token : string ) {
        const result = Cookie.get(token )
        // console.log('get:',result)
        return result || null
    },

    deleteToken(token: string ) {
        // console.log('delete:',token)
        Cookie.remove(token)
    },
}
